<script>
export default {
  props: {
    socialProfiles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      socialMediaLinks: [
        { key: 'facebook', icon: 'facebook', link: 'https://facebook.com/' },
        { key: 'twitter', icon: 'twitter', link: 'https://twitter.com/' },
        { key: 'linkedin', icon: 'linkedin', link: 'https://linkedin.com/' },
        { key: 'github', icon: 'github', link: 'https://github.com/' },
        { key: 'instagram', icon: 'instagram', link: 'https://instagram.com/' },
        { key: 'telegram', icon: 'telegram', link: 'https://t.me/' },
        { key: 'tiktok', icon: 'tiktok', link: 'https://tiktok.com/@' },
      ],
    };
  },
  computed: {
    availableProfiles() {
      return this.socialMediaLinks.filter(
        mediaLink => !!this.socialProfiles[mediaLink.key]
      );
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <!-- T-228 (24/09): o ícone sozinho não dizia nada. Aparecia o desenho do Instagram e mais
       nada, então o agente não sabia QUAL perfil era sem passar o mouse e ler a URL. Agora o
       identificador vem escrito ao lado, que é o que se usa para achar a pessoa. -->
  <div v-if="availableProfiles.length" class="flex flex-col gap-1 mx-0 my-2">
    <a
      v-for="profile in availableProfiles"
      :key="profile.key"
      :href="`${profile.link}${socialProfiles[profile.key]}`"
      target="_blank"
      rel="noopener noreferrer nofollow"
      class="flex items-center gap-2 text-sm text-n-slate-12 hover:underline"
    >
      <fluent-icon
        :icon="`brand-${profile.key}`"
        size="16"
        class="flex-shrink-0 text-n-slate-11"
      />
      <span class="truncate">@{{ socialProfiles[profile.key] }}</span>
    </a>
  </div>
</template>
